import { motion } from "framer-motion";

export const About = () => {
  return (
    <section id="about" className="relative py-14 lg:py-20 overflow-hidden">
      <div className="absolute top-0 -left-40 w-[500px] h-[500px] rounded-full bg-[#FF2A2A]/5 blur-3xl pointer-events-none" />
      <div className="relative max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-sm sm:text-base font-semibold tracking-[0.25em] uppercase text-[#D4AF37] mb-4">About Us</p>
          <h2 className="font-heading heading-fluid font-medium tracking-normal text-metal">
            Entertainment That Works, From Concept to Curtain Call
          </h2>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-12 space-y-6 text-lg text-zinc-300 leading-relaxed"
        >
          <p>
            Robust Entertainment is a full-service entertainment company built on more than 20 years of proven delivery
            across the UK holiday park and leisure industry.
          </p>
          <p>
            We provide everything a venue needs to create, launch and deliver outstanding entertainment, from original
            character branding and creative development to large-scale production shows, cabaret acts, promotional media,
            training programmes and professional sound, lighting and LED screen installations.
          </p>
          <p className="text-white font-medium text-xl">
            Our biggest strength is simple, clients do not need multiple suppliers. Robust Entertainment can provide the
            complete range of services through one experienced company, one joined-up creative vision and one trusted team.
          </p>
          <p>
            Whether you are developing a new family entertainment brand, improving your live show offering, upgrading your
            technical setup or training your entertainment team to deliver more confident guest experiences, Robust
            Entertainment brings the experience, creativity and reliability to make it happen.
          </p>
          <a
            href="https://wa.me/447539528505"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="about-cta"
            className="inline-block btn-glow-red bg-[#FF2A2A] hover:bg-[#FF4D4D] text-white font-medium px-8 py-4 rounded-full transition-all duration-300"
          >
            Let's Build Your Next Entertainment Experience
          </a>
        </motion.div>
        <div className="divider-gold mt-14" />
      </div>
    </section>
  );
};

export default About;
